import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import {
  SelectedTags,
  SharedToUsers,
  SharedToUsersAndTeams
} from '../components';
import { tryFetchSharableUsers, tryFetchSharableTeams } from '../flow/actions';

const defaultProps = {
  onTagRemove: null
};
const propTypes = {
  selectedData: PropTypes.array.isRequired,
  onTagRemove: PropTypes.func
};

class Section_SharedTo extends PureComponent {
  componentDidMount() {
    // fetch all users and teams
    this.props.tryFetchSharableUsers();
    this.props.tryFetchSharableTeams();
  }

  render() {
    const { selectedData, onTagRemove } = this.props;
    return (
      <div>
        <SelectedTags data={selectedData} onTagRemove={onTagRemove} />
        <div className="pb-md" />
        <SharedToUsers data={selectedData} />
        <SharedToUsersAndTeams />
      </div>
    );
  }
}

Section_SharedTo.defaultProps = defaultProps;
Section_SharedTo.propTypes = propTypes;
const mapStateToProps = () => ({});
const mapDispatchToProps = {
  tryFetchSharableUsers,
  tryFetchSharableTeams
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Section_SharedTo);



// WEBPACK FOOTER //
// ./src/views/Section_SharedTo/container/index.jsx